import { render, staticRenderFns } from "./shoppermission.vue?vue&type=template&id=6f2a95cb&scoped=true&"
import script from "./shoppermission.vue?vue&type=script&lang=js&"
export * from "./shoppermission.vue?vue&type=script&lang=js&"
import style0 from "./shoppermission.vue?vue&type=style&index=0&id=6f2a95cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a95cb",
  null
  
)

export default component.exports